import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import CsvExportTooltip from './CsvExportTooltip';
import Button from '../Button';

export const BaseCsvExportButton = ({
  id = 'csv-export-button',
  href,
  size,
  variant,
  isSquare,
  showIcon,
  loading,
  disabled,
  allowCsvExport,
  enableTooltip,
  tooltipText,
  buttonText,
  colorVariant,
  featureNameText,
  className,
  renderCustomTooltipContent,
  onClick,
  onVisibleChange,
}) => (
  <div className={cx('csv-export-link', className)}>
    <CsvExportTooltip
      id={`${id}--tooltip`}
      enableTooltip={enableTooltip}
      allowCsvExport={allowCsvExport}
      tooltipText={tooltipText}
      colorVariant={colorVariant}
      featureNameText={featureNameText}
      renderCustomTooltipContent={renderCustomTooltipContent}
      onVisibleChange={onVisibleChange}
    >
      <Button
        size={size}
        variant={variant}
        shape={isSquare ? 'square' : undefined}
        disabled={disabled}
        loading={loading}
        loadingId={`${id}--loading`}
        href={href && !disabled ? href : undefined}
        className="download-csv-link"
        onClick={onClick}
      >
        {showIcon && <i className="hicon-download-thin" />}
        {buttonText ? <span>{buttonText}</span> : null}
      </Button>
    </CsvExportTooltip>
  </div>
);

BaseCsvExportButton.propTypes = {
  id: T.string,
  href: T.string,
  size: T.string,
  variant: T.string,
  isSquare: T.bool,
  showIcon: T.bool,
  loading: T.bool,
  disabled: T.bool,
  enableTooltip: T.bool,
  allowCsvExport: T.bool,
  tooltipText: T.string,
  buttonText: T.string,
  featureNameText: T.string,
  className: T.string,
  colorVariant: T.string,
  renderCustomTooltipContent: T.func,
  onClick: T.func,
  onVisibleChange: T.func,
};
